export default {
  GET_EMPLOYEE_LIST_SUCCESS(state, data) {
    state.employeeList = data
    state.errors.employeeListError = null
  },
  GET_EMPLOYEE_LIST_ERROR(state, error) {
    state.errors.employeeListError = error
  },
  GET_EMPLOYEE_LIST_LOADING(state, payload) {
    state.loading.employeeListLoading = payload
  },
  SET_LOADING_PERSONAL_INN(state, data) {
    state.loading.personalInn = data
  },
  SET_LOADING_ORGANISATION_INN(state, data) {
    state.loading.organisationInn = data
  },
  GET_PERSONAL_NAME_SUCCESS(state, data) {
    state.personalInfo = data
    state.errors.personalInfoError = null
  },
  GET_PERSONAL_NAME_FAILURE(state, error) {
    state.errors.personalInfoError = error
  },
  GET_ORGANISATION_NAME_SUCCESS(state, data) {
    state.organisationInfo = data.name
    state.errors.organisationInfoError = null
  },
  GET_ORGANISATION_NAME_FAILURE(state, error) {
    state.errors.organisationInfoError = error
  },
  GET_DB_ACCESS_LIST_SUCCESS(state, data) {
    state.dbAccessList = data
    state.errors.dbAccessListError = null
  },
  GET_DB_ACCESS_LIST_ERROR(state, error) {
    state.errors.dbAccessListError = error
  },
  LOADING_ADD_NEW_EMPLOYEE(state, data) {
    state.loading.addNewEmployee = data
  },
  DELETE_EMPLOYEE_LOADING(state, payload) {
    state.loading.deleteEmployeeLoading = payload
  },
  DELETE_EMPLOYEE_SUCCESS(state, payload) {
    state.errors.deleteEmployeeError = null
  },
  DELETE_EMPLOYEE_ERROR(state, error) {
    state.errors.deleteEmployeeError = error
  },
  GET_EMPLOYEE_INFO_SUCCESS(state, data) {
    state.employeeInfoForEdit = data
    state.errors.employeeInfoForEditError = null
  },
  GET_EMPLOYEE_INFO_ERROR(state, error) {
    state.errors.employeeInfoForEditError = error
  },
  EDIT_EMPLOYEE_LOADING(state, payload) {
    state.loading.editEmployeeLoading = payload
  },
  EDIT_EMPLOYEE_SUCCESS(state, data) {
    state.editEmployeeAnswer = data
    state.errors.editEmployeeError = null
  },
  EDIT_EMPLOYEE_ERROR(state, error) {
    state.errors.editEmployeeError = error
  },
  CLEAR_EMPLOYEE_INFO_FOR_EDIT(state) {
    state.employeeInfoForEdit = []
  },
  GET_DB_LIST_FOR_NEW_EMPLOYEE_SUCCESS(state, payload) {
    state.dbListForNewEmployee = payload
    state.errors.dbListForNewEmployeeError = null
  },
  GET_DB_LIST_FOR_NEW_EMPLOYEE_ERROR(state, error) {
    state.errors.dbListForNewEmployeeError = error
  },
  ADD_NEW_EMPLOYEE_ERROR(state, error) {
    state.errors.addNewEmployeeError = error.response.data.message
  }
}



// WEBPACK FOOTER //
// ./src/store/employee/mutations.js